import { useApp } from '../../context/AppContext';

/**
 * Horizontal icon list used by EventFormSheet's "テンプレートから選択"
 * field. Selecting a template lets the parent prefill title/place/
 * color; selecting "使わない" just clears the selection
 * highlight (it does not reset already-typed fields).
 */
export default function TemplatePickerRow({ selectedId, onSelect }) {
  const { templates } = useApp();

  return (
    <div className="template-pick-row">
      <div
        className={`template-pick-item${selectedId === null ? ' selected' : ''}`}
        onClick={() => onSelect(null)}
      >
        <div className="tp-icon">🚫</div>
        <div className="tp-label">使わない</div>
      </div>

      {templates.map((t) => (
        <div
          key={t.id}
          className={`template-pick-item${selectedId === t.id ? ' selected' : ''}`}
          onClick={() => onSelect(t.id)}
        >
          <div className="tp-icon">
            {t.icons && t.icons.length > 0 ? (
              t.icons.map((ic, i) => <span key={i}>{ic}</span>)
            ) : (
              <span>📌</span>
            )}
          </div>
          <div className="tp-label">{t.name}</div>
        </div>
      ))}
    </div>
  );
}
